"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableSelectionButtons = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const selection_buttons_styles_1 = require("./selection-buttons.styles");
const localization_1 = require("../../../../localization");
const store_1 = require("../../../../store");
const TableSelectionButtons = ({ setLastSelectedRowId }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const handleSelectionButtonClick = (0, react_1.useCallback)((isExclusionModeOn) => {
        setLastSelectedRowId(null);
        dispatch((0, store_1.setIsExclusionModeOn)(isExclusionModeOn));
        dispatch((0, store_1.clearAllSelectedProducts)());
    }, [dispatch, setLastSelectedRowId]);
    return (react_1.default.createElement(selection_buttons_styles_1.StyledTableSelectionButtons, null, react_1.default.createElement(selection_buttons_styles_1.StyledTableSelectionButton, { title: t({ key: 'PRODUCT_EDITOR_TABLE_BUTTONS_SELCECT_ALL' }), onClick: () => handleSelectionButtonClick(true), variant: "text" }), react_1.default.createElement(selection_buttons_styles_1.StyledTableSelectionButton, { title: t({ key: 'PRODUCT_EDITOR_TABLE_BUTTONS_CLEAR_ALL' }), onClick: () => handleSelectionButtonClick(false), variant: "text" })));
};
exports.TableSelectionButtons = TableSelectionButtons;
exports.default = exports.TableSelectionButtons;
